// ----------------------------------------------------------------------------
// Snippet: Newsletter Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/icon/icon';

// Styles
import './_newsletter-form.scss';

(function(d){if(typeof _ltk=="undefined"){if(document.addEventListener)document.addEventListener("ltkAsyncListener",function(){_ltk_util.ready(d)});else{e=document.documentElement;e.ltkAsyncProperty=0;e.attachEvent("onpropertychange",function(e){if(e.propertyName=="ltkAsyncProperty"){_ltk_util.ready(d)}})}}else{_ltk_util.ready(d)}})(function(){
    _ltk.Signup.New('Footer', 'FooterNewsletterEmail',
        _ltk.Signup.TYPE.DEFAULT, 'FooterNewsletterSubmit', "email");
});
